import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const Overview = wrapSuspenseComponent(loadable(() => import('./Overview')))
const Creation = wrapSuspenseComponent(loadable(() => import('./Creation')))
const Profile = wrapSuspenseComponent(loadable(() => import('./Profile')))
const Settings = wrapSuspenseComponent(loadable(() => import('./Settings')))
const Members = wrapSuspenseComponent(loadable(() => import('./Members')))
const Forms = wrapSuspenseComponent(loadable(() => import('./Forms')))
const Monetization = wrapSuspenseComponent(loadable(() => import('./Monetization')))
const Messaging = wrapSuspenseComponent(loadable(() => import('./Messaging')))
const Embeds = wrapSuspenseComponent(loadable(() => import('./Embeds')))
const Bluesky = wrapSuspenseComponent(loadable(() => import('./Bluesky')))
const GoogleCalendar = wrapSuspenseComponent(loadable(() => import('./GoogleCalendar')))
const Meetup = wrapSuspenseComponent(loadable(() => import('./Meetup')))
const CalendarFeeds = wrapSuspenseComponent(loadable(() => import('./CalendarFeeds')))

const GuildsSection = () => (
  <DocsSection section='guilds'>
    <Routes>
      <Route index element={<Overview />} />
      <Route path='overview' element={<Overview />} />
      <Route path='creation' element={<Creation />} />
      <Route path='profile' element={<Profile />} />
      <Route path='settings' element={<Settings />} />
      <Route path='members' element={<Members />} />
      <Route path='forms' element={<Forms />} />
      <Route path='monetization' element={<Monetization />} />
      <Route path='messaging' element={<Messaging />} />
      <Route path='embeds' element={<Embeds />} />
      <Route path='bluesky' element={<Bluesky />} />
      <Route path='google-calendar' element={<GoogleCalendar />} />
      <Route path='meetup' element={<Meetup />} />
      <Route path='calendar-feeds' element={<CalendarFeeds />} />
    </Routes>
  </DocsSection>
)

export default GuildsSection
